export const templateADOnPrem = document.createElement('template');
import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';

templateADOnPrem.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div>
    <p id="domain-list-title"></p>
    <div id="domain_container"></div>
    <div id="no-results" class="hidden">
             <div class="separator"></div>
        <p id="no-results-text" class="mb-2 form-subtitle-info"></p>
    </div>
  </div>
`;
